import React from "react";
import styles from "../ReusableStyles.module.scss";

function PriceInputBox({ name, minMax }) {
  return (
    <div className={styles.priceBox}>
      <input type="text" placeholder={name} />
      <span>{minMax}</span>
    </div>
  );
}

export default PriceInputBox;
